export const NETWORK_ERROR_MSG = 'Network Error. Please try again';
export const REQUEST_TIMEOUT_MSG = 'Request Timeout';
export const ERROR_WITH_STATUS = 'Request Timeout';
export const SOMETHING_WENT_WRONG_MSG =
  'Something Went Wrong. Please Try Again.';
